"use client"

import React from "react"
import Image from "next/image"
import { motion } from "framer-motion"
import { useRouter } from "next/navigation"

const AvailableFor = () => {
    const router = useRouter()
    const opportunities = [
        {
            title: "Speaking",
            image: "/images/Speaking.jpg",
            button: false
        },
        {
            title: "Webinars",
            image: "/images/Speaking 2.jpg",
            button: false
        },
        {
            title: "Workshops",
            image: "/images/Workshop 2.jpg",
            button: true
        }
    ]

    return (
        <section className="bg-[#020617] py-20">
            <div className="max-w-[1800px] mx-auto px-8 lg:px-12">
                {/* Heading */}
                <div className="flex items-center gap-4 mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-white font-[family-name:var(--font-plus-jakarta-sans)]">
                        Available for
                    </h2>
                    <div className="w-16 h-px bg-blue-600" />
                </div>

                {/* Grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {opportunities.map((item, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.2 }}
                            className="relative aspect-square rounded-[32px] overflow-hidden group border border-white/5"
                        >
                            {/* Card Background (The Blue part) */}
                            <div className="absolute inset-0 bg-[#0c1b44] z-0" />

                            {/* Image with Fade Gradient */}
                            <div className="relative w-full h-full z-10 transition-transform duration-500 group-hover:scale-110">
                                <Image
                                    src={item.image}
                                    alt={item.title}
                                    fill
                                    className="object-cover"
                                />
                                {/* The Magic Fade - matching the image exactly */}
                                <div className="absolute inset-0 bg-gradient-to-t from-[#0c1b44] via-[#0c1b44]/40 to-transparent" />
                            </div>

                            <div className="absolute inset-0 z-20 flex flex-col items-center justify-end p-6 gap-4 group-hover:opacity-0 transition-opacity duration-300">
                                <h3 className="text-2xl font-extrabold text-white font-[family-name:var(--font-plus-jakarta-sans)]">
                                    {item.title}
                                </h3>
                            </div>

                            {/* Hover Overlay */}
                            <div className="absolute inset-0 z-30 flex flex-col items-center justify-center p-6 gap-6 opacity-0 group-hover:opacity-100 transition-all duration-500 bg-[#0c1b44]/60 backdrop-blur-[2px]">
                                <h3 className="text-3xl md:text-4xl font-bold text-white font-[family-name:var(--font-plus-jakarta-sans)] transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                                    {item.title}
                                </h3>
                                <button  onClick={() => router.push("#contact")} className="px-8 py-3 bg-white text-[#0c1b44] rounded-full font-bold text-lg transform translate-y-4 group-hover:translate-y-0 transition-all duration-500 delay-75 hover:scale-105 active:scale-95 shadow-xl">
                                    Check Availability
                                </button>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default AvailableFor
